<template>
  <div>
    <div>
      <div style="display: flex; align-items: center; gap: 6px">
        <!-- view all agents if coming from /all-agents-->
        <button class="btn btn-info m-2" @click="goBack">
          Back to All Agents
        </button>

        <button
          class="btn btn-info m-2"
          @click="doDisable"
          v-if="agent.disabled === false"
          :style="{ display: isAgent ? 'none' : 'block' }"
        >
          Disable Login Access
        </button>
        <button
          class="btn btn-info m-2"
          @click="doEnable"
          v-if="agent.disabled === true"
          :style="{ display: isAgent ? 'none' : 'block' }"
        >
          Enable Login Access
        </button>
        <button
          class="btn btn-info m-2"
          @click="doActivate"
          v-if="agent.activatedAt === null"
          :style="{ display: isAgent ? 'none' : 'block' }"
        >
          Activate Agent
        </button>
        <button
          class="btn btn-info m-2"
          @click="doActivatePND"
          v-if="wallet.pnd.status === 'inactive'"
          :style="{ display: isAgent ? 'none' : 'block' }"
        >
          Activate PND
        </button>
        <button
          class="btn btn-info m-2"
          @click="doDeactivatePND"
          v-if="wallet.pnd.status === 'active'"
          :style="{ display: isAgent ? 'none' : 'block' }"
        >
          DeActivate PND
        </button>

        <button
          v-if="wallet.liens && wallet.liens.length === 0"
          class="btn btn-info m-2"
          @click="openPlaceLienModal"
        >
          Place LIEN
        </button>
        <button
          v-if="wallet.liens && wallet.liens.length > 0"
          class="btn btn-info m-2"
          @click="openUpdatePlaceLienModal"
        >
          View LIEN
        </button>
      </div>

      <card class="card">
        <div class="accountEdit">
          <div>
            <div class="accountType">
              <p>Account Type</p>
              <div class="viewbtns">
                <span>{{ accountTypeDisplay }}</span>
                <button
                  class="btn btn-info m-2"
                  style="
                    padding: 8px 48px;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    justify-content: center;
                  "
                  :style="{ display: isAgent ? 'none' : 'block' }"
                  @click="openUpgradeModal"
                >
                  Upgrade
                </button>
              </div>
            </div>
          </div>

          <button
            class="btn btn-info m-2"
            :style="{ display: isAgent ? 'none' : 'block' }"
            style="padding: 8px 48px"
            @click="isEditable = true"
            v-if="!isEditable"
          >
            Edit
          </button>
          <button
            class="btn btn-info m-2"
            style="padding: 8px 48px"
            @click="isEditable = false"
            v-else
          >
            Cancel
          </button>
        </div>

        <div class="tabs-header">
          <span
            v-for="(tab, index) in tabs"
            :key="index"
            :class="{ active: activeTab === index }"
            @click="selectTab(index)"
          >
            {{ tab }}
          </span>
        </div>
        <div
          class="spinner-grow"
          role="status"
          style="position: relative; z-index: 50"
          v-if="loading === true"
        ></div>

        <div class="tab-content">
          <div v-if="activeTab === 0">
            <h3 style="font-size: 24px; font-weight: 700">
              Personal Information
            </h3>

            <div>
              <form @submit.prevent="updateForm">
                <div class="row">
                  <div class="col-md-4">
                    <fg-input
                      type="text"
                      label="First Name"
                      placeholder="First Name"
                      v-model="agent.firstName"
                      :readonly="isInputReadOnly"
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-4">
                    <fg-input
                      type="text"
                      label="Middle Name"
                      placeholder="Middle Name"
                      v-model="agent.middleName"
                      :readonly="isInputReadOnly"
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-4">
                    <fg-input
                      type="text"
                      label="Last Name"
                      placeholder="Last Name"
                      v-model="agent.lastName"
                      :readonly="isInputReadOnly"
                    >
                    </fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <fg-input
                      type="text"
                      label="Phone Number"
                      placeholder="Phone Number"
                      v-model="agent.phoneNumber"
                      :readonly="isInputReadOnly"
                      :maxlength="11"
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-4">
                    <fg-input
                      type="text"
                      id="dateOfBirth"
                      label="Date of Birth"
                      placeholder="Date of Birth"
                      v-model="formattedDOB"
                      :readonly="isInputReadOnly"
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-4">
                    <fg-input
                      type="text"
                      label="Gender"
                      placeholder="Gender"
                      v-model="agent.gender"
                      :readonly="isInputReadOnly"
                    >
                    </fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <fg-input
                      type="text"
                      label="Email Address"
                      placeholder="Email"
                      v-model="agent.email"
                      :readonly="!isEditable"
                    ></fg-input>
                  </div>
                  <div class="col-md-4">
                    <fg-input
                      type="text"
                      label="Nationality"
                      placeholder="NATIONALITY"
                      v-model="agent.nationality"
                      :readonly="isInputReadOnly"
                    ></fg-input>
                  </div>

                  <div
                    class="col-md-4"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      width: 100%;
                    "
                  >
                    <fg-input
                      type="text"
                      label="Bank Verification Number (BVN)"
                      placeholder="BVN"
                      :value="bvnValueDisplay()"
                      :disabled="true"
                      style="width: 100%"
                    ></fg-input>
                    <button
                      class="btn btn-info"
                      type="button"
                      style="margin-top: 12px"
                      @click="viewBvn"
                      :disabled="agent.bvnValid === false"
                      :style="{ display: isAgent ? 'none' : 'block' }"
                    >
                      {{ isBvnVisible ? "Hide BVN" : "View BVN" }}
                    </button>
                  </div>
                </div>

                <div class="row">
                  <div
                    class="col-md-4"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      width: 100%;
                    "
                  >
                    <fg-input
                      type="text"
                      label="National Identification Number (NIN)"
                      placeholder="NIN"
                      :value="showNin()"
                      :readonly="isInputReadOnly"
                      style="width: 100%"
                    ></fg-input>

                    <button
                      class="btn btn-info"
                      type="button"
                      style="margin-top: 12px"
                      @click="viewNIN"
                      :disabled="!agent.nin"
                      :style="{ display: isAgent ? 'none' : 'block' }"
                    >
                      {{ isNinVisible ? "Hide NIN" : "View NIN" }}
                    </button>
                  </div>
                  <div class="col-md-4">
                    <fg-input
                      type="text"
                      label="Residential Address"
                      placeholder="Address"
                      v-model="agent.address"
                      :readonly="!isEditable"
                    ></fg-input>
                  </div>
                  <div class="col-md-4">
                    <fg-input
                      type="text"
                      label="Landmark"
                      placeholder="Landmark"
                      v-model="agent.landmark"
                      :readonly="!isEditable"
                    ></fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <label>State of Origin</label>
                    <select
                      class="form-control op-border"
                      id="rate-type"
                      v-model="agent.state"
                      required
                      @change="fetchLgas()"
                      :disabled="isInputReadOnly"
                    >
                      <option value="">State</option>
                      <option
                        v-for="st in utils.allStates"
                        :key="st"
                        :value="st"
                      >
                        {{ st }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <div v-if="agent.bvnValid || agent.localGovernment">
                      <fg-input
                        type="text"
                        label="LGA of Origin"
                        placeholder="LGA"
                        v-model="agent.localGovernment"
                        :readonly="isInputReadOnly"
                      ></fg-input>
                    </div>
                    <div v-else>
                      <label for="localGovernment">L.G.A of Origin</label>
                      <select
                        id="localGovernment"
                        class="form-control"
                        v-model="agent.localGovernment"
                        required
                        :disabled="isInputReadOnly"
                      >
                        <option value="" disabled>
                          Select Local Government
                        </option>
                        <option
                          v-for="lga in utils.lgas"
                          :key="lga.id"
                          :value="lga.name"
                        >
                          {{ lga.name }}
                        </option>
                      </select>
                      <span v-if="utils.lgaLoading">Fetching LGAs...</span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div>
                      <label>Social Media Platform</label>
                      <select
                        class="form-control op-border"
                        id="social-media-platform"
                        v-model="agent.socialMedia.socialMediaPlatform"
                        :disabled="!isEditable"
                      >
                        <option value="">Select Media Platform</option>
                        <option value="Facebook">Facebook</option>
                        <option value="Instagram">Instagram</option>
                        <option value="Twitter">Twitter</option>
                        <option value="Linkedin">Linkedin</option>
                        <option value="Tiktok">Tiktok</option>
                        <option value="Snapchat">Snapchat</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <label>State of Residence</label>
                    <select
                      class="form-control op-border"
                      id="rate-type"
                      v-model="agent.stateOfResidence"
                      required
                      @change="fetchResidenceLgas()"
                      :disabled="!isEditable"
                    >
                      <option value="">State</option>
                      <option
                        v-for="st in utils.allStates"
                        :key="st"
                        :value="st"
                      >
                        {{ st }}
                      </option>
                    </select>
                  </div>

                  <div class="col-md-4">
                    <div
                      v-if="
                        !isEditable && (agent.bvnValid || agent.lgaOfResidence)
                      "
                    >
                      <fg-input
                        type="text"
                        label="LGA of Residence"
                        placeholder="LGA"
                        v-model="agent.lgaOfResidence"
                        :readonly="isInputReadOnly"
                      ></fg-input>
                    </div>
                    <div v-if="isEditable">
                      <label for="lga.lgaOfResidence">L.G.A of Residence</label>
                      <select
                        id="lgaOfResidence"
                        class="form-control"
                        v-model="agent.lgaOfResidence"
                        required
                      >
                        <option value="" disabled>
                          Select Local Government
                        </option>
                        <option
                          v-for="lga in utils.lgas"
                          :key="lga.id"
                          :value="lga.name"
                        >
                          {{ lga.name }}
                        </option>
                      </select>
                      <span v-if="utils.lgaLoading">Fetching LGAs...</span>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <fg-input
                      type="text"
                      label="Social Media Handle"
                      placeholder="Socials"
                      v-model="agent.socialMedia.socialMediaHandle"
                      :readonly="!isEditable"
                    ></fg-input>
                  </div>
                </div>

                <h4>Sources of Income</h4>
                <div v-if="sourcesOfIncome">
                  <div class="row">
                    <div class="col-md-4">
                      <label>Occupation</label>
                      <select
                        class="form-control op-border"
                        id="occupation"
                        v-model="agent.sourcesOfIncome[0].occupation"
                        :disabled="!isEditable"
                      >
                        <option value="">Select Occupation</option>
                        <option v-for="role in occupations" :key="role.key">
                          {{ role.label }}
                        </option>
                      </select>
                    </div>

                    <div class="col-md-4">
                      <label>What is your annual income</label>
                      <select
                        class="form-control op-border"
                        id="annualIncome"
                        v-model="agent.sourcesOfIncome[0].annualIncome"
                        :disabled="!isEditable"
                      >
                        <option value="">Select AnnualIncome</option>
                        <option
                          v-for="price in annualIncome"
                          :key="price.key"
                          :value="price.key"
                        >
                          {{ price.label }}
                        </option>
                      </select>
                    </div>

                    <div class="col-md-4">
                      <label>Other sources of income?</label>
                      <select
                        class="form-control op-border"
                        id="selectedOtherIncome"
                        v-model="selectedOtherIncome"
                        :disabled="!isEditable"
                      >
                        <option value="">Select Other sources of income</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>

                  <div
                    class="row"
                    v-if="
                      selectedOtherIncome === 'Yes' ||
                      agent.sourcesOfIncome.length > 1
                    "
                  >
                    <div class="col-md-4">
                      <label>Other Occupation</label>
                      <select
                        class="form-control op-border"
                        id="occuption"
                        v-model="agent.sourcesOfIncome[1].occupation"
                        required
                        :disabled="!isEditable"
                      >
                        <option value="">Select Occupation</option>
                        <option v-for="role in occupations" :key="role.key">
                          {{ role.label }}
                        </option>
                      </select>
                    </div>

                    <div class="col-md-4">
                      <label>What is your annual income?</label>
                      <select
                        class="form-control op-border"
                        id="annualIncome"
                        v-model="agent.sourcesOfIncome[1].annualIncome"
                        :disabled="!isEditable"
                      >
                        <option value="">Select AnnualIncome</option>
                        <option
                          v-for="price in annualIncome"
                          :key="price.key"
                          :value="price.key"
                        >
                          {{ price.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <h4>Agent’s Category</h4>
                    <!-- <label>Merchant </label> -->
                    <select
                      class="form-control op-border"
                      id="rate-type"
                      v-model="agent.merchantId"
                      required
                      :disabled="!isEditable"
                    >
                      <option value="">Select Merchant</option>
                      <option
                        v-for="merchant in allMerchants"
                        :key="merchant.id"
                        :value="merchant._id"
                      >
                        {{ merchant.merchantName }}
                      </option>
                    </select>
                  </div>

                  <div class="col-md-4">
                    <h4>Agent’s Sales Officer</h4>

                    <!-- <label>Sales Officer </label> -->

                    <v-select
                      v-model="agent.salesOfficerId"
                      :options="formattedSalesOfficers"
                      :reduce="(officer) => officer._id"
                      label="fullName"
                      :disabled="!isEditable"
                      placeholder="Select Sales Officer"
                      searchable
                      style="border: none"
                    />
                  </div>
                </div>

                <h4>Activation Details</h4>
                <div class="row">
                  <div class="col-md-4">
                    <fg-input
                      type="text"
                      label="Activated On"
                      placeholder="Activation date & time"
                      v-model="formattedActivationDate"
                      :disabled="true"
                    >
                    </fg-input>
                  </div>

                  <div class="col-md-4">
                    <fg-input
                      type="text"
                      label="Activated By"
                      placeholder="Activated by"
                      v-model="agent.activitedBy"
                      :disabled="true"
                    >
                    </fg-input>
                  </div>
                </div>

                <div
                  class="text-center"
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                  "
                >
                  <button
                    type="info"
                    class="btn btn-info m-2"
                    round
                    @click.native.prevent="updateForm"
                    :style="{ display: isEditable ? 'block' : 'none' }"
                  >
                    <div
                      class="spinner-grow"
                      role="status"
                      v-if="loading.show === true"
                    ></div>
                    Update Account
                  </button>
                </div>
                <div class="clearfix"></div>
              </form>
            </div>
          </div>

          <!-- UPLOAD KYC -->
          <div v-if="activeTab === 1">
            <h3 style="font-size: 24px; font-weight: 700">KYC Documents</h3>

            <div class="upload-kyc-section">
              <form @submit.prevent="submitKYC">
                <div class="row">
                  <div class="col-md-4 p-2">
                    <label for="">NIN Image</label>
                    <input
                      type="file"
                      class="form-control"
                      @change="handleNINUpload"
                      :disabled="!isEditable"
                    />
                  </div>
                  <div class="col-md-4 p-2">
                    <label for="">Proof of Address</label>
                    <input
                      type="file"
                      class="form-control"
                      @change="handleAddressUpload"
                      :disabled="!isEditable"
                    />
                  </div>
                  <div class="col-md-4 p-2">
                    <label for="">Image</label>
                    <input
                      type="file"
                      class="form-control"
                      name="idCardImg"
                      @change="handleIdCardUpload"
                      :disabled="!isEditable"
                    />
                  </div>
                </div>

                <h3 style="font-size: 24px; font-weight: 700">
                  Uploaded Documents
                </h3>

                <div class="row">
                  <div
                    class="col-md-4"
                    style="
                      display: flex;
                      align-items: center;
                      flex-direction: column;
                      justify-content: center;
                    "
                  >
                    <label style="color: #000">NIN Image</label><br />
                    <template v-if="agent.idCardImgUrl">
                      <div
                        class="thumbnail"
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                        @mouseover="showViewLink(agent.idCardImgUrl)"
                        @mouseleave="hideViewLink(agent.idCardImgUrl)"
                      >
                        <img
                          v-if="isImage(agent.idCardImgUrl)"
                          :src="agent.idCardImgUrl"
                          class="img-thumbnail"
                          alt="Proof of Address"
                        />
                        <!-- Show PDF preview if it's a PDF -->
                        <div
                          v-else-if="isPDF(agent.idCardImgUrl)"
                          class="pdf-thumbnail"
                        >
                          <img
                            src="../assets/img/pdf.png"
                            class="pdf-icon"
                            alt="PDF File"
                            style="width: 150px"
                          />
                        </div>

                        <div
                          v-if="isViewLinkVisible(agent.idCardImgUrl)"
                          class="view-link"
                        >
                          <a
                            v-if="isPDF(agent.idCardImgUrl)"
                            :href="agent.idCardImgUrl"
                            target="_blank"
                            class="btn btn-info"
                          >
                            View
                          </a>
                          <a
                            v-else
                            @click="expandImage(agent.idCardImgUrl)"
                            class="btn btn-info"
                          >
                            View
                          </a>
                        </div>
                        <div
                          v-if="isExpanded(agent.idCardImgUrl)"
                          class="expanded-image"
                        >
                          <img
                            v-if="isImage(agent.idCardImgUrl)"
                            :src="agent.idCardImgUrl"
                            class="img-thumbnail"
                            alt="Proof of Address"
                          />

                          <div class="action-btns">
                            <button
                              class="btn btn-info btn-sm"
                              @click="saveImage(agent.idCardImgUrl)"
                            >
                              Save
                            </button>
                            <button
                              class="btn btn-danger btn-sm"
                              @click="closeImage(agent.idCardImgUrl)"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div></div>
                    </template>
                  </div>

                  <div
                    class="col-md-4"
                    style="
                      display: flex;
                      align-items: center;
                      flex-direction: column;
                    "
                  >
                    <label style="color: #000">Proof of Address</label><br />
                    <template v-if="agent.addressImgUrl">
                      <div
                        class="thumbnail"
                        style="
                          display: flex;
                          align-items: center;
                          flex-direction: column;
                        "
                        @mouseover="showViewLink(agent.addressImgUrl)"
                        @mouseleave="hideViewLink(agent.addressImgUrl)"
                      >
                        <img
                          v-if="isImage(agent.addressImgUrl)"
                          :src="agent.addressImgUrl"
                          class="img-thumbnail"
                          alt="Proof of Address"
                        />

                        <!-- Show PDF icon if file is a PDF -->
                        <div
                          v-else-if="isPDF(agent.addressImgUrl)"
                          class="pdf-thumbnail"
                        >
                          <img
                            src="../assets/img/pdf.png"
                            class="pdf-icon"
                            alt="PDF File"
                            style="width: 150px"
                          />
                        </div>
                        <div
                          v-if="isViewLinkVisible(agent.addressImgUrl)"
                          class="view-link"
                        >
                          <a
                            v-if="isPDF(agent.addressImgUrl)"
                            :href="agent.addressImgUrl"
                            target="_blank"
                            class="btn btn-info"
                          >
                            View
                          </a>
                          <a
                            v-else
                            @click="expandImage(agent.addressImgUrl)"
                            class="btn btn-info"
                          >
                            View
                          </a>
                        </div>
                        <div
                          v-if="isExpanded(agent.addressImgUrl)"
                          class="expanded-image"
                        >
                          <img
                            v-if="isImage(agent.addressImgUrl)"
                            :src="agent.addressImgUrl"
                            class="img-thumbnail"
                            alt="Proof of Address"
                          />

                          <div class="action-btns">
                            <button
                              class="btn btn-info btn-sm"
                              @click="saveImage(agent.addressImgUrl)"
                            >
                              Save
                            </button>
                            <button
                              class="btn btn-danger btn-sm"
                              @click="closeImage(agent.addressImgUrl)"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div></div>
                    </template>
                  </div>

                  <div
                    class="col-md-4"
                    style="
                      display: flex;
                      align-items: center;
                      flex-direction: column;
                    "
                  >
                    <label style="color: #000">Image</label><br />
                    <template v-if="agent.profileImgUrl">
                      <div
                        class="thumbnail"
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                        @mouseover="showViewLink(agent.profileImgUrl)"
                        @mouseleave="hideViewLink(agent.profileImgUrl)"
                      >
                        <img
                          v-if="isImage(agent.profileImgUrl)"
                          :src="agent.profileImgUrl"
                          class="img-thumbnail"
                          alt="Id Card"
                        />
                        <div
                          v-else-if="isPDF(agent.profileImgUrl)"
                          class="pdf-thumbnail"
                        >
                          <img
                            src="../assets/img/pdf.png"
                            class="pdf-icon"
                            alt="PDF File"
                            style="width: 150px"
                          />
                        </div>
                        <div
                          v-if="isViewLinkVisible(agent.profileImgUrl)"
                          class="view-link"
                        >
                          <a
                            v-if="isPDF(agent.profileImgUrl)"
                            :href="agent.profileImgUrl"
                            target="_blank"
                            class="btn btn-info"
                          >
                            View
                          </a>
                          <a
                            v-else
                            @click="expandImage(agent.profileImgUrl)"
                            class="btn btn-info"
                          >
                            View
                          </a>
                        </div>
                        <div
                          v-if="isExpanded(agent.profileImgUrl)"
                          class="expanded-image"
                        >
                          <img
                            v-if="isImage(agent.profileImgUrl)"
                            :src="agent.profileImgUrl"
                            class="img-thumbnail"
                            alt="Id Card"
                          />

                          <div class="action-btns">
                            <button
                              class="btn btn-info btn-sm"
                              @click="saveImage(agent.profileImgUrl)"
                            >
                              Save
                            </button>
                            <button
                              class="btn btn-danger btn-sm"
                              @click="closeImage(agent.profileImgUrl)"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div></div>
                    </template>
                  </div>
                </div>

                <div
                  class="text-center"
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    padding: 10px;
                  "
                >
                  <button
                    type="info"
                    class="btn btn-info m-2"
                    round
                    @click.native.prevent="submitKYC"
                    :style="{ display: isEditable ? 'block' : 'none' }"
                  >
                    <div
                      class="spinner-grow"
                      role="status"
                      v-if="loading.show === true"
                    ></div>
                    Update KYC
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </card>
    </div>

    <UpgradeModal
      :isVisible="showUpgradeModal"
      :agentId="agent._id"
      :agentFirstName="agent.firstName"
      :agentMiddleName="agent.middleName"
      :agentLastName="agent.lastName"
      @close="closeModal"
    />

    <PlaceLienModal
      :isVisible="showPlaceLienModal"
      :agentId="agent._id"
      :isEditLien="isEditLien"
      @close="closeLienModal"
      :agentLienDetails="agentLienDetails"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "../store/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { readonly } from "vue";
import { annualIncome, occupation } from "../constants/agents-information";
import UpgradeModal from "./Modals/UpgradeModal.vue";
import SearchableDropdown from "../components/SearchableDropdown.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import PlaceLienModal from "./Modals/PlaceLienModal.vue";

export default {
  components: {
    UpgradeModal,
    SearchableDropdown,
    PlaceLienModal,
    vSelect,
  },
  data() {
    return {
      agent: {
        bvn: "",
        businessName: "",
        email: "",
        address: "",
        phoneNumber: "",
        gender: "",
        lastName: "",
        firstName: "",
        middleName: "",
        dateOfBirth: "",
        country: "",
        state: "",
        localGovernment: "",
        lgaOfResidence: "",
        stateOfResidence: "",
        merchantId: "",
        _id: "",
        idCardImg: null,
        profileImgUrl: null,
        addressImg: null,
        date: "",
        time: "",
        showModal: false,
        socialMedia: {
          socialMediaPlatform: "",
          socialMediaHandle: "",
        },
        sourcesOfIncome: [],
        bvnDataId: {
          id: "",
        },
      },

      wallet: {
        pnd: {
          status: "",
        },
        liens: [],
      },

      allMerchants: [],
      loading: false,
      viewLinkVisible: {},
      expandedImages: [],
      activeTab: 0,
      tabs: ["Personal Information", "KYC Documents"],
      isEditable: false,
      occupations: occupation,
      annualIncome: annualIncome,
      showUpgradeModal: false,
      showPlaceLienModal: false,
      bvnValue: "",
      ninValue: "",
      allSalesOfficers: [],
      isNinVisible: false,
      isBvnVisible: false,
      isEditLien: null,
      agentLienDetails: {},
      userType: localStorage.getItem("userType"),
    };
  },

  computed: {
    isAgent() {
      return this.userType === "Merchant";
    },
    ...mapState(["auth", "utils"]),
    accountTypeDisplay() {
      if (this.agent.accountType == "individual-account") {
        return "Individual Account";
      } else if (this.agent.accountType == "business-account") {
        return "Business Account";
      }
      return "";
    },
    formattedActivationDate() {
      if (this.agent.activatedAt) {
        const timestamp = moment(this.agent.activatedAt);
        return timestamp.format("DD-MM-YYYY HH:mm a");
      } else {
        return "";
      }
    },
    formattedDOB: {
      get() {
        return moment(this.agent.dateOfBirth).format("DD-MM-YYYY");
      },
      set(newValue) {
        this.agent.dateOfBirth = moment(newValue).toISOString();
      },
    },

    isInputReadOnly() {
      return !this.isEditable || this.agent.bvnValid;
    },
    isKYCIncomplete() {
      return this.agent.idCardImg && this.agent.addressImg && this.agent.ninImg;
    },

    sourcesOfIncome() {
      return this.agent.sourcesOfIncome.length
        ? this.agent.sourcesOfIncome
        : [{}];
    },

    selectedOtherIncome: {
      get() {
        return this.agent.sourcesOfIncome.length > 1 ? "Yes" : "No";
      },
      set(value) {
        if (value === "Yes" && this.agent.sourcesOfIncome.length === 1) {
          this.agent.sourcesOfIncome.push({ occupation: "", annualIncome: "" });
        } else if (value === "No" && this.agent.sourcesOfIncome.length > 1) {
          this.agent.sourcesOfIncome.splice(1);
        }
      },
    },

    formattedSalesOfficers() {
      return this.allSalesOfficers.map((o) => ({
        ...o,
        fullName: `${o.firstName} ${o.lastName || ""}`.trim(),
      }));
    },
  },

  methods: {
    isImage(fileUrl) {
      return /\.(jpg|jpeg|png|gif|bmp)$/i.test(fileUrl);
    },
    isPDF(fileUrl) {
      return /\.pdf$/i.test(fileUrl);
    },

    selectTab(index) {
      this.activeTab = index;
    },

    toggleEditMode() {
      this.isEditable = true;
    },

    goBack() {
      if (window.history.length > 1) this.$router.go(-1);
    },

    ...mapActions([
      "getStates",
      "getLgas",
      "getCountries",
      "getMerchant",
      "updateAgent",
      "setNotification",
      "enableAgent",
      "disableAgent",
      "activateAgent",
      "activatePND",
    ]),
    submit() {
      this.$confirm("Update Agent?").then(() => {
        this.updateAgent(this.agent);
      });
    },

    doDisable() {
      this.$confirm("Disable Login Access, Are you sure?").then(() => {
        this.disableAgent({ id: this.agent._id });
        this.getAgent();
      });
    },
    doEnable() {
      this.$confirm("Enable Login Access?").then(() => {
        this.enableAgent({ id: this.agent._id });
        this.getAgent();
      });
    },

    async doActivatePND() {
      console.log("click");
      try {
        await this.$confirm("Place Post No Debit on Account?");
        await this.activatePND({ agentId: this.agent._id, status: "active" });
        await this.getAgent();
        // window.location.reload();
      } catch (error) {
        this.$toast.error(error.response.data.message);
      }
    },

    async doDeactivatePND() {
      console.log("click");
      try {
        await this.$confirm("Remove Post No Debit from Account?");
        await this.activatePND({ agentId: this.agent._id, status: "inactive" });
        await this.getAgent();
        // window.location.reload();
      } catch (error) {
        this.$toast.error(error.response.data.message);
      }
    },

    async doActivate() {
      try {
        await this.$confirm("Activate Agent?");

        await this.activateAgent({ id: this.agent._id });
        await this.getAgent();

        window.location.reload();
      } catch (err) {
        console.log("Activation cancelled or an error occurred:", err);
      }
    },

    async getAgent() {
      try {
        // this.loading = true;
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/agent/${this.$route.params.agentId}`,
        );
        const { agent, wallet } = res.data;
        this.agent = agent;
        this.wallet = wallet;
        this.agent.state = this.agent.state.toLowerCase().includes("state")
          ? this.agent.state
          : `${this.agent.state} State`;

        this.agent.stateOfResidence = this.agent.stateOfResidence
          .toLowerCase()
          .includes("state")
          ? this.agent.stateOfResidence
          : `${this.agent.stateOfResidence} State`;
        this.loading = false;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch Agent Data",
          });
        }
      }
    },

    async getSalesOfficers() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/user/get-all-users`,
        );

        this.allSalesOfficers = res.data.users;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Sales Officers",
          });
        }
      }
    },

    async getMerchants() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/merchant/get-all-merchants`,
        );
        const { merchants } = res.data;
        this.allMerchants = merchants;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },
    fetchLgas() {
      this.agent.localGovernment = "";
      this.getLgas(this.agent.state);
    },
    fetchResidenceLgas() {
      this.agent.lgaOfResidence = "";
      this.getLgas(this.agent.stateOfResidence);
    },
    handleIdCardUpload(event) {
      const file = event.target.files[0];
      this.agent.idCardImg = file;
    },
    handleAddressUpload(event) {
      const file = event.target.files[0];
      this.agent.addressImg = file;
    },
    handleNINUpload(event) {
      const file = event.target.files[0];
      this.agent.ninImg = file;
    },

    async updateForm() {
      this.loading = true;
      this.errorMessage = null;

      const filteredSources =
        this.selectedOtherIncome === "No"
          ? [this.agent.sourcesOfIncome[0]]
          : this.agent.sourcesOfIncome;

      const payload = {
        firstName: this.agent.firstName,
        middleName: this.agent.middleName,
        lastName: this.agent.lastName,
        phoneNumber: this.agent.phoneNumber,
        dateOfBirth: this.agent.dateOfBirth,
        email: this.agent.email,
        gender: this.agent.gender.toLowerCase(),
        nationality: this.agent.nationality,
        nin: this.agent.nin,
        bvn: this.agent.bvn,
        address: this.agent.address,
        landmark: this.agent.landmark,
        state: this.agent.state,
        stateOfResidence: this.agent.stateOfResidence,
        localGovernment: this.agent.localGovernment,
        lgaOfResidence: this.agent.lgaOfResidence,
        socialMediaPlatform: this.agent.socialMedia.socialMediaPlatform,
        socialMediaHandle: this.agent.socialMedia.socialMediaHandle,
        merchantId: this.agent.merchantId,
        accountType: this.agent.accountType,
        sourcesOfIncome: filteredSources.map((source) => ({
          occupation: source.occupation || "",
          annualIncome: source.annualIncome || "",
        })),
        salesOfficerId: this.agent.salesOfficerId,
      };
      console.log(payload);

      try {
        this.loading = true;

        const response = await axios.put(
          `${process.env.VUE_APP_API_URL}/kyc/update-personal-details/${this.agent._id}`,
          payload,
        );

        if (response.data.status === "success") {
          Swal.fire({
            title: "Agent Updated Successfully",
            text: `${response.data.message}`,
            icon: "success",
            confirmButtonText: "OK",
            showCancelButton: false,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });

          this.loading = false;
        } else if (response.data.status === "failed") {
          Swal.fire({
            title: "Agent Update Failed",
            text: `${response.data.message}`,
            icon: "error",
            confirmButtonText: "OK",
            showCancelButton: false,
          });
          this.loading = false;
        } else {
          this.loading = false;
        }
      } catch (err) {
        console.log(err);
        this.loading = false;
        Swal.fire({
          title: "Agent Update Failed",
          text: `Validation Error: ${err.response.data.message}`,
          icon: "error",
          confirmButtonText: "OK",
          showCancelButton: false,
        });
      }
    },

    submitKYC() {
      this.loading = true;
      if (this.agent.idCardImg == null && this.agent.addressImgUrl == null) {
        this.$confirm("Upload all documents to proceed");
        return;
      }
      const formData = new FormData();
      formData.append("agentId", this.agent._id);
      formData.append("liveSelfie", this.agent.idCardImg || "");
      formData.append("addressImg", this.agent.addressImg || "");
      formData.append("ninImg", this.agent.ninImg || "");
      this.loading = true;
      axios
        .put(
          `${process.env.VUE_APP_API_URL}/kyc/update-kyc-docs/${this.agent._id}`,
          formData,
        )

        .then((response) => {
          // this.$confirm("KYC Submitted Successfully");

          Swal.fire({
            title: "KYC Submitted Successfully",
            icon: "success",
            confirmButtonText: "OK",
            showCancelButton: false,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showViewLink(imageUrl) {
      this.$set(this.viewLinkVisible, imageUrl, true);
    },
    hideViewLink(imageUrl) {
      this.$set(this.viewLinkVisible, imageUrl, false);
    },
    isViewLinkVisible(imageUrl) {
      return this.viewLinkVisible[imageUrl] || false;
    },
    expandImage(imageUrl) {
      if (!this.isExpanded(imageUrl)) {
        this.expandedImages.push(imageUrl);
      }
    },
    closeImage(imageUrl) {
      this.expandedImages = this.expandedImages.filter(
        (imgUrl) => imgUrl !== imageUrl,
      );
    },

    isExpanded(imageUrl) {
      return this.expandedImages.includes(imageUrl);
    },
    saveImage() {
      const fileUrl = this.expandedImages;

      fetch(this.expandedImages)
        .then((response) => response.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;

          if (this.isPDF(fileUrl)) {
            link.download = `${this.agent.firstName}-${this.agent.lastName}-kyc.pdf`;
          } else {
            link.download = `${this.agent.firstName}-${this.agent.lastName}-kyc.jpg`;
          }

          link.click();
          URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Error downloading image:", error);
        });
    },

    async openUpgradeModal() {
      this.showUpgradeModal = true;
    },

    closeModal() {
      this.showUpgradeModal = false;
      console.log("modal closed");
    },

    async openPlaceLienModal() {
      this.isEditLien = false;
      this.showPlaceLienModal = true;
    },

    async openUpdatePlaceLienModal() {
      this.isEditLien = true;
      this.showPlaceLienModal = true;
      this.agentLienDetails = this.wallet.liens[0];
    },

    closeLienModal() {
      this.showPlaceLienModal = false;
      this.showUpdateLienModal = false;
      this.isEditLien = null;
      this.window.location.reload();
    },

    async viewBvn() {
      if (this.isBvnVisible) {
        // hide BVN
        this.bvnValue = null;
        this.isBvnVisible = false;
      } else {
        try {
          this.loading = true;
          const res = await axios.post(
            `${process.env.VUE_APP_API_URL}/decrypt/${this.$route.params.agentId}/bvn`,
          );

          this.bvnValue = res.data.bvn;
          this.isBvnVisible = true;
        } catch (err) {
          const { data } = err.response.data;
          if (data) {
            this.setNotification({
              type: "danger",
              message: data.message || "Unable to Fetch Agent Data",
            });
          }
        } finally {
          this.loading = false;
        }
      }
    },

    async viewNIN() {
      if (this.isNinVisible) {
        // hide NIN
        this.ninValue = null;
        this.isNinVisible = false;
      } else {
        // show NIN
        this.loading = true;
        try {
          const res = await axios.post(
            `${process.env.VUE_APP_API_URL}/decrypt/${this.$route.params.agentId}/bvn`,
          );
          this.ninValue = res.data.nin;
          this.isNinVisible = true;
        } catch (err) {
          const { data } = err.response.data || {};
          if (data) {
            this.setNotification({
              type: "danger",
              message: data.message || "Unable to Fetch Agent Data",
            });
          }
        } finally {
          this.loading = false;
        }
      }
    },

    bvnValueDisplay() {
      if (this.bvnValue) {
        return this.bvnValue;
      }
      return this.agent.bvnValid ? "True" : "False";
    },

    showNin() {
      if (this.ninValue) {
        return this.ninValue;
      }
      return this.agent.nin ? "True" : "False";
    },
  },

  watch: {
    agent: {
      handler(newAgent) {
        if (!newAgent.sourcesOfIncome.length) {
          this.agent.sourcesOfIncome = [{}];
        }
      },
      deep: true,
      immediate: true,
    },
  },

  async mounted() {
    this.getStates();
    this.getMerchants();
    await this.getAgent();
    await this.getSalesOfficers();

    this.$nextTick(() => {
      this.selectedOtherIncome =
        this.agent.sourcesOfIncome.length > 1 ? "Yes" : "No";
    });
  },
};
</script>

<style>
.accountEdit {
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
}
.accountEdit .accountType {
  flex: 1;
}

.viewbtns {
  display: flex;
  align-items: center;
  gap: 10px;
}

.tabs-header {
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 24px;
  border-bottom: 1px solid #9a9a9a;
  color: #9a9a9a;
  margin-bottom: 30px;
}
span.active {
  padding: 8px 20px;
  color: #1eb75b;
  border-bottom: 1px solid #1eb75b;
  font-weight: 600;
}
.upload-kyc-section {
  padding: 10px;
}
.thumbnail {
  position: relative;
  display: inline-block;
  border-radius: 10px;
}
.thumbnail img {
  width: 50%;
  height: auto;
  /* border-radius: 10px; */
}

.view-link {
  position: absolute;
  top: 50%;
  left: 50% !important;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.3s ease;
  cursor: pointer;
}

.view-link a {
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff !important;
  text-decoration: none;
}
.thumbnail:hover .overlay {
  opacity: 1;
}
.thumbnail:hover .view-link {
  opacity: 1;
}
.thumbnail:hover .expanded-image {
  opacity: 1;
  visibility: visible;
  transition: opacity 0.3s ease;
}
.expanded-image {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0s linear 0.3s;
}
.expanded-image img {
  max-height: 85%;
}
.action-btns {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.action-btns button {
  margin: 5px;
  padding: 8px 10px;
}
.spin {
  border: 2px solid rgba(101, 179, 199, 0.2) !important;
  border-left-color: #65b3c7 !important;
  display: block;
  width: 20px !important;
  height: 20px !important;
}
</style>
